import { RouteObject } from 'react-router-dom'

import accountPortalRoutes from '~/app/providers/router/accountPortalRoutes'
import adminPortalRoutes from '~/app/providers/router/adminPortalRoutes'
import authRoutes from '~/app/providers/router/authRoutes'
import marketingRoutes from '~/app/providers/router/marketingRoutes'
import onboardingDemoRoutes from '~/app/providers/router/onboardingDemoRoutes'
import {
  partnerAdminOnlyPortalRoutes,
  partnerEditorPortalRoutes,
} from '~/app/providers/router/partnerAdminPortalRoutes'
import PartnerAuth from '~/features/partners/components/partnerLogin'
import AccountLayout from '~/layouts/account'
import AdminRestrictedLayout from '~/layouts/adminOutlet'
import AppLayout from '~/layouts/app'
import AuthLayout from '~/layouts/auth'
import ChatBotLayout from '~/layouts/chatbot'
import ConfigLayout from '~/layouts/configOutlet'
import PartnerRestrictedLayout from '~/layouts/partnerAdminOutlet'
import RootConfigLayout from '~/layouts/rootConfig'
import SeoConfigLayout from '~/layouts/seo'
import WhiteLabelLayout from '~/layouts/whiteLabel'
import { EClientPath } from '~/models/api'
import { ECognitoGroups } from '~/models/auth'
import ChatBotPage from '~/pages/chatbot'
import Help247Page from '~/pages/help247Page'

const routes: RouteObject[] = [
  {
    element: <RootConfigLayout />,
    children: [
      {
        element: <SeoConfigLayout />,
        children: [
          { path: EClientPath.help247, element: <Help247Page /> },
          {
            element: <ConfigLayout />,
            children: [
              {
                element: <AuthLayout />,
                children: authRoutes,
              },
              {
                element: <AppLayout />,
                children: marketingRoutes,
              },
              {
                element: <AccountLayout />,
                children: accountPortalRoutes,
              },
              {
                element: <AdminRestrictedLayout />,
                children: adminPortalRoutes,
              },
              {
                path: EClientPath.partnerAdmin,
                element: (
                  <PartnerRestrictedLayout
                    allowedGroups={[ECognitoGroups.partnerAdmin]}
                  />
                ),
                children: partnerAdminOnlyPortalRoutes,
              },
              {
                path: EClientPath.partnerAdmin,
                element: (
                  <PartnerRestrictedLayout
                    allowedGroups={[
                      ECognitoGroups.partnerAdmin,
                      ECognitoGroups.partnerEditor,
                    ]}
                  />
                ),
                children: partnerEditorPortalRoutes,
              },
              {
                element: <WhiteLabelLayout />,
                children: onboardingDemoRoutes,
              },
            ],
          },
          {
            element: <ChatBotLayout />,
            children: [
              EClientPath.chat,
              EClientPath.legacyChat,
              EClientPath.anything,
            ].map((path) => ({
              path,
              element: <ChatBotPage />,
            })),
          },
          {
            element: <PartnerAuth />,
            path: EClientPath.partnerAuth,
          },
        ],
      },
    ],
  },
]

export default routes
